export const oxxioExpandableTokens = {
  expandableIndicatorBackground: '{{ backgroundColors.backgroundBrand }}',
  expandableDefaultIndicatorColor: '{{ iconColors.iconInverted }}',
  expandableTransparentIndicatorColor: '{{ iconColors.iconBrand }}',
};
